export enum RoleType {
    Root = 1,
    ChiefEngineer = 2,
    SeniorEngineer = 3,
    SuperAdmin = 4,
    SuperintendEngineer = 5,
    ExecutiveEngineer = 6,
    AssistantExecutiveEngineer = 7,
    AssistantEngineer = 8,
    Foreman = 9,
    WSAE = 10,
    WSAEE = 11,
    Farmer = 12,
    HOOfficial = 13,
    AEAllocationEngineer = 14,
    APC = 15,
    HOFinance = 16,
    ITDept = 17,
    Manufacturer = 18,
    Dealer = 19,
    BothManufacturerDealer = 20,
    DBTAdmin = 21,
    Tnega = 22,
    GPS = 23,
    CMAPIAdmin = 24,
    RCS = 25,
    JR = 26,
    PAACS = 27,
    // JDA = 28,
    // Agriadmin = 29,
    // ADagri = 30
    AgricultureAdmin = 28,
    HorticultureAdmin = 29,
    AgriJDA = 30,
    Agriada = 31,
    HortiJDHorDDH = 32,
    HortiADH = 33,
    AgricultureChiefEngineer = 34,
    HorticultureChiefEngineer = 35,
    AgricultureAAO = 36,  
    AgricultureAO = 37,  
    AgricultureDD = 38,  
    HorticultureAHO = 39,  
    Technician = 40,  
    ServiceProvider = 41,  
    Driver = 42,
    FOCSR = 44
}


